import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "lib-scope-extended",
  templateUrl: "./scope-extended.component.html",
  styleUrl: "./scope-extended.component.scss",
})
export class ScopeExtendedComponent implements OnInit, OnDestroy {
  @Input() userApplications: any[] = [];
  @Input() userPermissionresourseList: any;
  @Input() applicationName: any;
  @Input() initialEntries: any[] = [];

  @Output() entriesChange = new EventEmitter<any[]>();
  @Output() validEntries = new EventEmitter<any>();

  formArray: FormArray = this.fb.array([]);
  form = this.fb.group({
    entries: this.formArray,
  });

  validNoApps: number = 0;
  private destroy$ = new Subject<void>();

  constructor(public fb: FormBuilder) {}

  ngOnInit() {
    this.formArraySetter();

    this.formArray.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((changes) => {
      this.emitChange();
      this.emitValidScope();
    });
    let apps = this.userApplications.filter((app) =>  ![this.applicationName,'App Builder'].includes(app.applicationName));
    this.validNoApps = apps.length;
  }

  formArraySetter() {
    if (this.initialEntries) {
      let entries = this.convertToObj(this.initialEntries);
      if(entries){

        this.patchInitialValues(entries);
      }
    }
  }

  checkValidApps() {
    let invalid = false;
    if(this.userApplications.length <= 2) {
    let check = this.userApplications.some((app:any) => app.applicationName === 'App Builder');
    if(check) {
      invalid = true;
    }
  }

    return invalid;
  }


  convertToObj(entries: any) {
    let newentries: any = [];
    entries.forEach((entry: any) => {
      newentries.push(JSON.parse(entry));
    });

    return newentries;
  }

  private patchInitialValues(entries: any) {
    this.formArray.clear();
    for (const entry of entries || []) {
      this.formArray.push(this.createEntryGroup(entry));
    }
    this.emitChange();
  }

  createEntryGroup(entry: any = {}): FormGroup {
    let group = this.fb.group({
      application: [ entry.application ?? '',Validators.required],  // Initialize with empty values first
      resource: [ entry.resource ?? [], Validators.required]
    });
    
    group.markAsPristine();
    group.markAsUntouched();
    return group;
  }

  addEntry() {
    if (this.canAddNewEntry()) {
      this.formArray.push(this.createEntryGroup());
    }
  }

  deleteEntry(index: number) {
    this.formArray.removeAt(index);
    this.emitChange();
  }

  canAddNewEntry(): boolean {
    return this.formArray.valid && this.getAvailableApplications().length > 0;
  }

  emitValidScope() {
    this.validEntries.emit({valid:this.formArray.valid,applicationName: this.applicationName});
  }

  emitChange() {
    this.entriesChange.emit(this.formArray.getRawValue());
  }

  getAvailableApplications(currentIndex?: number): any[] {
    const selectedAppIds = this.formArray.controls
      .map((group, index) => {
        if (currentIndex !== undefined && index === currentIndex) {
          return null;
        }
        return group.get("application")?.value;
      })
      .filter(Boolean);
    return this.userApplications.filter((app) => !selectedAppIds.includes(app.applicationId) && ![this.applicationName,'App Builder'].includes(app.applicationName));
  }

  get canAddEntry(): boolean {
    const selectedApps = this.formArray.controls
      .map(group => group.get('application')?.value)
      .filter(Boolean);
  
    return this.userApplications.some(
      app => !selectedApps.some(sel => sel?.applicationName === app.applicationName)
    );
  }

  compareApps = (a: any, b: any): boolean => {
    return a === b;
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
